var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4557_4825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41634 1.25016L6.13892 3.12886C6.25642 3.43437 6.31517 3.58712 6.40654 3.71562C6.48751 3.8295 6.58701 3.92899 6.70089 4.00997C6.82938 4.10133 6.98214 4.16008 7.28765 4.27759L9.16634 5.00016L7.28765 5.72274C6.98214 5.84024 6.82938 5.89899 6.70089 5.99036C6.58701 6.07133 6.48751 6.17083 6.40654 6.28471C6.31517 6.4132 6.25642 6.56596 6.13892 6.87147L5.41634 8.75016L4.69377 6.87147C4.57626 6.56596 4.51751 6.4132 4.42615 6.28471C4.34517 6.17083 4.24567 6.07133 4.13179 5.99036C4.0033 5.89899 3.85055 5.84024 3.54503 5.72274L1.66634 5.00016L3.54503 4.27759C3.85055 4.16008 4.0033 4.10133 4.13179 4.00997C4.24567 3.92899 4.34517 3.8295 4.42615 3.71562C4.51751 3.58712 4.57626 3.43437 4.69377 3.12886L5.41634 1.25016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87467 9.16683V7.0835M1.87467 2.91683V0.833496M0.833008 1.87516H2.91634M0.833008 8.12516H2.91634M5.41634 1.25016L4.69377 3.12886C4.57626 3.43437 4.51751 3.58712 4.42615 3.71562C4.34517 3.8295 4.24567 3.92899 4.13179 4.00997C4.0033 4.10133 3.85055 4.16008 3.54503 4.27759L1.66634 5.00016L3.54503 5.72274C3.85055 5.84024 4.0033 5.89899 4.13179 5.99036C4.24567 6.07133 4.34517 6.17083 4.42615 6.28471C4.51751 6.4132 4.57626 6.56596 4.69377 6.87147L5.41634 8.75016L6.13892 6.87147C6.25642 6.56596 6.31517 6.4132 6.40654 6.28471C6.48751 6.17083 6.58701 6.07133 6.70089 5.99036C6.82938 5.89899 6.98214 5.84024 7.28765 5.72274L9.16634 5.00016L7.28765 4.27759C6.98214 4.16008 6.82938 4.10133 6.70089 4.00997C6.58701 3.92899 6.48751 3.8295 6.40654 3.71562C6.31517 3.58712 6.25642 3.43437 6.13892 3.12886L5.41634 1.25016Z",
    stroke: "#DCEBFC",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4557_4825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.a0cb022b.svg";
export { ForwardRef as ReactComponent };